import { PaymentRequestStatus } from '@wellro/models';

export function transformPaymentRequestStatus(
  value: PaymentRequestStatus
): string {
  switch (value) {
    case PaymentRequestStatus.PendingPayment:
      return 'Payment pending';
    case PaymentRequestStatus.PaymentComplete:
      return 'Payment Completed';
    case PaymentRequestStatus.PaymentFailed:
      return 'Payment Failed';
    case PaymentRequestStatus.Expired:
      return 'Expired';
  }
}
